<template>
    <div>
        <fluke-card>
            <header>
                <div class="title">Editar Pergunta</div>
                <div class="description">Altere as informações necessárias</div>
            </header>
            <main>
                <v-text-field label="Pergunta" v-model="question" :disabled="permission.write?null:true"></v-text-field>
                <fluke-editor :disabled="permission.write?null:true" v-model="anwser" :key="keyer" />
                <br>
                <br>
                <span v-if="courses.length">Aparece em:</span>
                <ul v-if="courses.length">
                    <li v-for="(item, index) in courses" :key="index">
                        <a @click="openCourse(item.id)" class="openCourse">[ver curso]</a> {{item.title}}<br>
                    </li>
                </ul>
                <div v-if="!courses.length">Essa pergunta náo está em nenhum curso ainda.</div>
            </main>
            <footer>
                <fluke-button v-on:click.native="cancel" color="grey">cancelar</fluke-button>
                <fluke-button v-on:click.native="submit" v-if="permission.write">Salvar</fluke-button>
            </footer>
        </fluke-card>

        <div class="right" v-if="permission.write">
            <a v-on:click="remove" class="remove-links">Remover Pergunta</a>
        </div>
        <global-popup ref="remove" title="Remover">Deseja remover essa pergunta?</global-popup>
    </div>
</template>

<script>
import axios from 'axios';

import Card from '../../components/Main/Content/Card/Card.vue';
import Button from '../../components/Main/Content/Button/Button.vue';
import Editor from '../../components/Main/Content/Editor/Editor';

import permission from '../../mixins/permissions';


export default {
    mixins: [ permission ],
    components: {
        'fluke-card': Card,
        'fluke-button': Button,
        'fluke-editor': Editor,
    },
    data: function() {
        return {
            question: '',
            anwser: '',
            keyer: 0,
            permission: {
                read: false,
                write: false
            },
            courses: []
        }
    },
    created: function(){
        this.getData();
        this.permission = this.getUserPagePermission('faq');
		if( this.permission.read == false ) {
			this.$router.push('/');
		}
    },
    watch: {
        lastSpots: function()
        {
            if( this.lastSpots && this.closed ) this.closed = false;
        },
        closed: function()
        {
            if( this.lastSpots && this.closed ) this.lastSpots = false;
        }
    },
    methods: {
        dateCompare: function(date1, date2)
        {
            var d1 = date1.beginDate;
            var d2 = date2.beginDate;
            var comparison = 0;

            if( d1 > d2 ) comparison = 1;
            else if( d1 < d2 )comparison = -1;

            return comparison;
        },
        getData: async function(){
            this.id = this.$route.params.id;

            const result = await axios.get(
				this.$myServerAddresses.courses + 'faq/' + this.id, {
                    headers: {
                        'X-Fluke': this.$cookies.get('token')
                    }
                }
            );
            this.question = result.data.question;
            this.anwser = result.data.anwser;

            const courses = await axios.get(
                this.$myServerAddresses.courses + 'faq/list_courses/' + this.id,
                {
                    headers: {
                        'X-Fluke': this.$cookies.get('token')
                    }
                }
            );
            this.courses = courses.data;
            this.keyer += 1;
        },
        submit: async function() {
            const result = await axios.put(
				this.$myServerAddresses.courses + 'faq',
				{
                    id: this.id,
                    question: this.question,
                    anwser: this.anwser
				},
                {
                    headers: {
                        'X-Fluke': this.$cookies.get('token')
                    }
                }
            );
            this.$router.push({ name: 'faq' });
        },
        openCourse( course ) {
            this.$router.push({ name: 'courses-edit', params: { id: course } });
        },
        remove: async function () {

            this.$refs.remove
                .confirm()
                .then(()=>{
                    axios.delete(
                        this.$myServerAddresses.courses + 'faq/' + this.id,
                        {
                            headers: {
                                'X-Fluke': this.$cookies.get('token')
                            }
                        }
                    ).then(()=>{
                        this.$router.push({ name: 'faq' });
                    });
                });
        },
        cancel: function() {
            this.$router.push({ name: 'faq' });
        },
    }
}
</script>

<style lang="scss">
.openCourse {
    cursor: pointer;
    font-weight: 500;
    color: $accent-color;
}
</style>
